import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postApiCodelistManagementDownloadConfigsIdTrigger } from "Infrastructure/Api/Api";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { DOWNLOAD_CONFIGS_QUERY_KEY } from "../Queries/useDownloadConfigsQuery";
import { CODELIST_FILES_QUERY_KEY } from "../Queries/useCodeListFilesQuery";

export function useTriggerDownloadMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();

	return useMutation({
		mutationFn: (id: number) =>
			postApiCodelistManagementDownloadConfigsIdTrigger(id),
		onSuccess: (response) => {
			if (response.status === 200) {
				if (response.data.success) {
					const paths = response.data.uploadedPaths;
					showSnackbar(
						`Stažení dokončeno (${paths.length} souborů)`,
						"success"
					);
				} else {
					showSnackbar("Stažení selhalo", "error");
				}
				queryClient.invalidateQueries({
					queryKey: [CODELIST_FILES_QUERY_KEY],
				});
			} else if (response.status === 404) {
				showSnackbar("Konfigurace nenalezena", "error");
			} else {
				showSnackbar("Stažení selhalo", "error");
			}
			// Always refresh configs to show updated status
			queryClient.invalidateQueries({
				queryKey: [DOWNLOAD_CONFIGS_QUERY_KEY],
			});
		},
		onError: () => {
			showSnackbar("Chyba při spuštění stahování", "error");
			queryClient.invalidateQueries({
				queryKey: [DOWNLOAD_CONFIGS_QUERY_KEY],
			});
		},
	});
}
